import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    salutation: string,
    street: string,
    postalCode: string,
    city: string,
    dateOfBirth: Date | null,
    entranceDate: Date | null,
    salaryRequestFrom: number | null,
    salaryRequestTo: number | null,
    schoolEducation: string,
    nationality: string,
    becomingAwareThrough: string,
    areaOfDeployment: string,
    letterFile: File | undefined,
    applicantPhotoFile: File | undefined,
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    salutation: string = "";
    street: string = "";
    postalCode: string = "";
    city: string = "";
    dateOfBirth: Date | null = null;
    entranceDate: Date | null = null;
    salaryRequestFrom: number | null = null;
    salaryRequestTo: number | null = null;
    schoolEducation: string = "";
    nationality: string = "";
    becomingAwareThrough: string = "";
    areaOfDeployment: string = "";
    letterFile: File | undefined = undefined;
    applicantPhotoFile: File | undefined = undefined;
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "salutation", value: this.salutation },
            { name: "street", value: this.street },
            { name: "postalCode", value: this.postalCode },
            { name: "city", value: this.city },
            { name: "dateOfBirth", value: this.dateOfBirth?.toString() ?? "" },
            { name: "entranceDate", value: this.entranceDate?.toString() ?? "" },
            { name: "salaryRequestFrom", value: this.salaryRequestFrom?.toString() ?? "" },
            { name: "salaryRequestTo", value: this.salaryRequestTo?.toString() ?? "" },
            { name: "schoolEducation", value: this.schoolEducation },
            { name: "nationality", value: this.nationality },
            { name: "becomingAwareThrough", value: this.becomingAwareThrough },
            { name: "areaOfDeployment", value: this.areaOfDeployment },
        );

        return application;
    }
}
